var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"icon loading"}),_c('div',{attrs:{"id":"container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }